import React, { useEffect, useState } from 'react';
//redux
import { get, isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import {
  studentDownloadlist,
  studentDownloadFile
} from '../../../../actions/downloadActions';
import { dateFormat } from '../../../../api/dateFormat';
//material Imports
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
//components
import CardLayout from '../../../../components/DataTextCard/Layout';
import PageHeading from '../../../../components/PageHeading';
import NoData from '../../../../components/NoData';
import LoadingSkeleton from '../../../../components/LoadingSkeleton';
import Skeleton from '@material-ui/lab/Skeleton';

export default function DownloadLayout() {
  // State
  const [isFetching, setIsFetching] = useState(false);
  const [isFetchingDetails, setIsFetchingDetails] = useState(false);
  const [uniqueCode, setUniqueCode] = useState(0);

  // Redux
  const dispatch = useDispatch();
  const loginData = useSelector(state =>
    get(state, 'loginReducer.data.jwt', {})
  );
  const downloadList = useSelector(state =>
    get(state, 'downloadReducer.data', [])
  );
  const downloadDetails = useSelector(state =>
    get(state, 'downloadReducer.downloadDetails.listDownloadFile', [])
  );
  const errorMessage = useSelector(state =>
    get(state, 'downloadReducer.errorMessage', '')
  );

  //functions
  useEffect(() => {
    setIsFetching(true);
    studentDownloadlist(loginData, dispatch).then(() => {
      setIsFetching(false);
    });
  }, []);

  useEffect(() => {
    if (uniqueCode !== 0) {
      setIsFetchingDetails(true);
      studentDownloadFile(uniqueCode, loginData, dispatch).then(() => {
        setIsFetchingDetails(false);
      });
    }
  }, [uniqueCode]);

  const handleUniqueCode = code => {
    setUniqueCode(code);
  };

  //Download Detail Data
  const dataList = () => {
    const array = isFetchingDetails
      ? [1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
      : downloadDetails;
    const list = [];
    !isEmpty(downloadDetails) &&
      array.map((data, index) => {
        list.push(
          <a
            href={data.DownloadFileURL}
            target="_blank"
            rel="noopener noreferrer"
            download
            key={index}
          >
            <ListItem button>
              {isFetchingDetails ? (
                <Skeleton width="100%" />
              ) : (
                <>
                  <ListItemText primary={data.DownloadFileTitle} />
                  <span className="icon-view">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 50 50"
                      fill="currentColor"
                      width="20"
                    >
                      <path d="M47.81,24.09c-.41-.46-10.35-11.3-22.81-11.3S2.6,23.63,2.19,24.09a1.35,1.35,0,0,0,0,1.82c.41.46,10.35,11.3,22.81,11.3s22.4-10.84,22.81-11.3A1.35,1.35,0,0,0,47.81,24.09ZM25,34.5A9.5,9.5,0,1,1,34.5,25,9.51,9.51,0,0,1,25,34.5Z" />
                      <path d="M26.36,22.29A4,4,0,0,1,28.07,19a6.78,6.78,0,1,0,3.6,7.16A4,4,0,0,1,26.36,22.29Z" />
                    </svg>
                  </span>
                </>
              )}
            </ListItem>
          </a>
        );
      });
    return list;
  };

  const populateDownloadList = () => {
    let list = [];
    if (!isEmpty(downloadList))
      downloadList.map((data, index) => {
        return list.push(
          <div
            topic={data.DownloadTItle}
            key={index}
            date={dateFormat(data.DownloadDate)}
            uniqueCode={data.UniqueCode}
            handler={() => {
              handleUniqueCode(data.UniqueCode);
            }}
            list={dataList()}
            headerText="Downloads"
          ></div>
        );
      });
    return list;
  };

  return (
    <React.Fragment>
      <PageHeading titlePrimary="Downloads" />

      {isFetching ? (
        <LoadingSkeleton type="smallcardlist" />
      ) : !isEmpty(populateDownloadList()) ? (
        <CardLayout value={0} index={0}>
          {populateDownloadList()}
        </CardLayout>
      ) : (
        <NoData
          message={!isEmpty(errorMessage) ? errorMessage : 'No data Available'}
        />
      )}
    </React.Fragment>
  );
}
